import React from 'react';
import { useState, useEffect, Fragment } from "react";
import DataTable from 'react-data-table-component';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { PiDownload } from "react-icons/pi";
import Alert from 'react-bootstrap/Alert';

const SearchtheRules = () => {
    const [usecase, setUsecase] = useState('');
    const [client, setClient] = useState('');
    const [category, setCategory] = useState('');
    const [rule, setRule] = useState('');
    const [showTable, setShowTable] = useState(false);
    const [errors, setErrors] = useState({});
    const handleGoClick = () => {
        const newErrors = {};
        if (!usecase) newErrors.usecase = 'Usecase is required';
        if (!client) newErrors.client = 'Client is required';
        if (!category) newErrors.category = 'Category is required';
        if (!rule) newErrors.rule = 'Rule is required';

        setErrors(newErrors);

        if (Object.keys(newErrors).length === 0) {
            setShowTable(true);
        } else {
            setShowTable(false);
        }
    };

    const handleSelectChange = (field, value) => {
        setShowTable(false); // Reset table view on input change
        setErrors(prev => ({ ...prev, [field]: '' })); // Clear error for that field

        if (field === 'usecase') setUsecase(value);
        if (field === 'client') setClient(value);
        if (field === 'category') setCategory(value);
    };

    const handleRuleChange = (e) => {
        setShowTable(false);
        setRule(e.target.value);
        setErrors(prev => ({ ...prev, rule: '' }));
    };
    const columns = [
        {
            name: 'Client Name',
            selector: row => row.clientname,
            sortable: true,
        },
        {
            name: 'Category',
            selector: row => row.category,
            sortable: true,
        },
        {
            name: 'Rule Name',
            selector: row => row.rulename,
            sortable: true,
        },
        {
            name: 'Type',
            selector: row => row.type,
            sortable: true,
        },
        {
            name: 'Version',
            selector: row => row.version,
            sortable: true,
        },
        {
            name: 'Modified Date',
            selector: row => row.modifieddate,
            sortable: true,
        },
        {
            name: 'Question',
            selector: row => row.question,
            sortable: true,
        },
        {
            name: 'Download',
            selector: row => row.download,
            sortable: true,
             cell: row => (
                <div style={{ display: 'flex', textAlign: 'center', alignItems: 'center' }}>
                    <Button
                        variant="link"
                        size="sm"
                        aria-label="Edit"                        
                    >
                        <PiDownload style={{fontSize: '16px'}}  />

                    </Button>

              
                 
                </div>
            )
        },
    ];

    const data = [
        {
            id: 1,
            clientname: 'FSB',
            category: 'Asset',
            rulename: 'R_DGEN0000',
            type: 'Base',
            version: 'Version 1.1',
            modifieddate: '02/28/2022',
            question: 'If Asset #4 <> NULL',
            download: '',
        },
         {
            id: 2,
            clientname: 'RoundPoint',
            category: 'Credit',
            rulename: 'R_DAST1014',
            type: 'Client',
            version: 'Version 2.3',
            modifieddate: '12/12/2021',
            question: 'Is Date Opened > 2 month prior to application?',
            download: '',
        },

         {
            id: 3,
            clientname: 'FSB',
            category: 'Asset',
            rulename: 'R_DAST1004',
            type: 'Base',
            version: 'Version 4.2',
            modifieddate: '01/16/2020',
            question: 'Is Average Balance >= account balance on 1003?',
            download: '',
        },

         {
            id: 4,
            clientname: 'RoundPoint',
            category: 'Credit',
            rulename: 'R_DAST1024',
            type: 'Base',
            version: 'Version 3.1',
            modifieddate: '01/19/2020',
            question: 'Is Line 12 of VOD populated?',
            download: '',
        },

         {
            id: 5,
            clientname: 'FSB',
            category: 'Asset',
            rulename: 'R_DGEN0000',
            type: 'Base',
            version: 'Version 1.1',
            modifieddate: '02/28/2022',
            question: 'If Asset #4 <> NULL',
            download: '',
        },


    ]

    return (
        <Fragment>
             <Alert variant="light">
            <Form>
                <Row>
                    <Col sm={3} className='pe-0'>
                        <Form.Group as={Row}>
                            <Form.Label column sm="4" className='pe-0'>UsecaseName <span style={{ color: 'red' }}>*</span></Form.Label>
                            <Col sm="8"> 
                                <Form.Select size="sm" value={usecase} onChange={(e) => handleSelectChange('usecase', e.target.value)}>
                                    <option value="">Select Usecase</option>
                                    <option value="Usecase1">Usecase 1</option>
                                </Form.Select>
                                {errors.usecase && <small className="text-danger">{errors.usecase}</small>}
                            </Col>
                        </Form.Group>
                    </Col>

                    <Col sm={3} className='ps-0'>
                        <Form.Group as={Row}>
                            <Form.Label column sm="3" className='text-end'>Client <span style={{ color: 'red' }}>*</span></Form.Label>
                            <Col sm="9">
                                <Form.Select size="sm" value={client} onChange={(e) => handleSelectChange('client', e.target.value)}>
                                    <option value="">Select Client</option>
                                    <option value="Client1">Client 1</option>
                                </Form.Select>
                                {errors.client && <small className="text-danger">{errors.client}</small>}
                            </Col>
                        </Form.Group>
                    </Col>

                    <Col sm={3} className='ps-0'>
                        <Form.Group as={Row}>
                            <Form.Label column sm="3" className='text-end pe-0'>Category <span style={{ color: 'red' }}>*</span></Form.Label>
                            <Col sm="9">
                                <Form.Select size="sm" value={category} onChange={(e) => handleSelectChange('category', e.target.value)}>
                                    <option value="">Select Category</option>
                                    <option value="Category1">Category 1</option>
                                </Form.Select>
                                {errors.category && <small className="text-danger">{errors.category}</small>}
                            </Col>
                        </Form.Group>
                    </Col>

                    <Col sm={3} className='ps-0'>
                        <Form.Group as={Row}>
                            <Form.Label column sm="3" className='text-end'>Rule <span style={{ color: 'red' }}>*</span></Form.Label>
                            <Col sm="7">
                                <Form.Control size="sm" type="text" placeholder="Enter Rule" value={rule} onChange={handleRuleChange} />
                                {errors.rule && <small className="text-danger">{errors.rule}</small>}
                            </Col>
                            <Col sm={2}>
                                <Button variant="primary" size='sm' onClick={handleGoClick}>Go</Button>
                            </Col>
                        </Form.Group>
                    </Col>
                </Row>
            </Form>
</Alert>
            {showTable && (
                <Row>
                    <Col sm={12}>
                        <DataTable
                            columns={columns}
                            data={data}
                            dense
                            pagination
                            responsive
                            selectableRows
                        />
                    </Col>
                </Row>
            )}
        </Fragment>
    );
};

export default SearchtheRules;